var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LayoutProvider, UiProvider } from "@uigovpe/components";
import { PostLoginRedirect } from "./modules/auth/PostLoginRedirect";
import { AppShell } from "./modules/layout/AppShell";
export var App = function () {
    var shell = (_jsxs(_Fragment, { children: [_jsx(PostLoginRedirect, {}), _jsx(AppShell, {})] }));
    return (_jsx(LayoutProvider, __assign({ breakpoint: 1024 }, { children: process.env.NODE_ENV === "test" ? (shell) : (_jsx(UiProvider, { children: shell })) })));
};
